import { color, size, spacing, } from "@mittwald/flow-styles/dist/tokens/ts/variables";
import { createGlobalStyle } from "styled-components";
export const TooltipGlobalStyle = createGlobalStyle `
  :root {
    --tooltip-bg-color: ${color.font.text.default};
  }

  .tippy-box[data-animation=fade][data-state=hidden] {
    opacity: 0
  }

  [data-tippy-root] {
    max-width: calc(100vw - 10px)
  }

  .tippy-box {
    position: relative;
    background-color: var(--tooltip-bg-color);
    color: ${color.font.text.inverse.default};
    border-radius: ${size.borderRadius};
    white-space: normal;
    outline: 0;
    transition-property: transform, visibility, opacity
  }

  .tippy-box[data-placement^=top] > .tippy-arrow {
    bottom: 0
  }

  .tippy-box[data-placement^=top] > .tippy-arrow:before {
    bottom: -7px;
    left: 0;
    border-width: 8px 8px 0;
    border-top-color: initial;
    transform-origin: center top
  }

  .tippy-box[data-placement^=bottom] > .tippy-arrow {
    top: 0
  }

  .tippy-box[data-placement^=bottom] > .tippy-arrow:before {
    top: -7px;
    left: 0;
    border-width: 0 8px 8px;
    border-bottom-color: initial;
    transform-origin: center bottom
  }

  .tippy-box[data-placement^=left] > .tippy-arrow {
    right: 0
  }

  .tippy-box[data-placement^=left] > .tippy-arrow:before {
    border-width: 8px 0 8px 8px;
    border-left-color: initial;
    right: -7px;
    transform-origin: center left
  }

  .tippy-box[data-placement^=right] > .tippy-arrow {
    left: 0
  }

  .tippy-box[data-placement^=right] > .tippy-arrow:before {
    left: -7px;
    border-width: 8px 8px 8px 0;
    border-right-color: initial;
    transform-origin: center right
  }

  .tippy-box[data-inertia][data-state=visible] {
    transition-timing-function: cubic-bezier(.54, 1.5, .38, 1.11)
  }

  .tippy-arrow {
    width: 16px;
    height: 16px;
    color: var(--tooltip-bg-color);
  }

  .tippy-arrow:before {
    content: "";
    position: absolute;
    border-color: transparent;
    border-style: solid
  }

  .tippy-content {
    position: relative;
    padding: ${spacing.base.s} ${spacing.base.m};
    z-index: 1
  }

  .tippy-content small {
    font-size: ${size.font.smallText} !important;
    font-family: "MW-Flow-Regular" !important;
  }

`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVG9vbHRpcEdsb2JhbFN0eWxlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvVG9vbHRpcFNpbmdsZXRvbi9zdHlsZWQvVG9vbHRpcEdsb2JhbFN0eWxlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFDTCxLQUFLLEVBQ0wsSUFBSSxFQUNKLE9BQU8sR0FDUixNQUFNLGdEQUFnRCxDQUFDO0FBQ3hELE9BQU8sRUFBRSxpQkFBaUIsRUFBRSxNQUFNLG1CQUFtQixDQUFDO0FBRXRELE1BQU0sQ0FBQyxNQUFNLGtCQUFrQixHQUFHLGlCQUFpQixDQUFBOzswQkFFekIsS0FBSyxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsT0FBTzs7Ozs7Ozs7Ozs7Ozs7YUFjcEMsS0FBSyxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsT0FBTyxDQUFDLE9BQU87cUJBQ3ZCLElBQUksQ0FBQyxZQUFZOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztlQXVFdkIsT0FBTyxDQUFDLElBQUksQ0FBQyxDQUFDLElBQUksT0FBTyxDQUFDLElBQUksQ0FBQyxDQUFDOzs7OztpQkFLOUIsSUFBSSxDQUFDLElBQUksQ0FBQyxTQUFTOzs7O0NBSW5DLENBQUMifQ==